import { Controller } from "@hotwired/stimulus"

// Read More controller - truncates long text with expand/collapse functionality
// Usage:
//   <div data-controller="read-more" data-read-more-max-length-value="100">
//     <span data-read-more-target="content">Long text here...</span>
//     <button data-action="click->read-more#toggle" data-read-more-target="button">Ver mais</button>
//   </div>
export default class extends Controller {
  static targets = ["content", "button"]
  static values = {
    maxLength: { type: Number, default: 100 }
  }

  connect() {
    this.originalText = this.contentTarget.textContent
    this.truncate()
  }

  truncate() {
    if (this.originalText.length > this.maxLengthValue) {
      this.contentTarget.textContent = this.originalText.slice(0, this.maxLengthValue) + "..."
      this.buttonTarget.textContent = "Ver mais"
      this.buttonTarget.classList.remove("hidden")
    } else {
      this.buttonTarget.classList.add("hidden")
    }
  }

  toggle(event) {
    event.preventDefault()

    if (this.buttonTarget.textContent === "Ver mais") {
      // Expand
      this.contentTarget.textContent = this.originalText
      this.buttonTarget.textContent = "Ver menos"
    } else {
      // Collapse
      this.truncate()
    }
  }
}
